import React from 'react'
import { connect } from 'react-redux'
import { getRecoveryLabelAction, getRecoveryBarCodeAction } from '../../../../actions/appActions'
import {
    Dialog,
    DialogContent,
    DialogTitle,
    DialogActions,
    Button,
    IconButton,
} from '@material-ui/core/index'
import CloseIcon from '@material-ui/icons/Close'
import PrintIcon from '@material-ui/icons/Print'
import GetAppIcon from '@material-ui/icons/GetApp'
import { strings } from '../../../../localization/strings'
import Loader from '../../../loaders/dots_loader/index'

const styles = {
    recoveryCode: {
        width: '300px',
        margin: '20px auto',
        overflow: 'hidden',
        position:'relative',
        height: '335px'
    },
    closeBtn: {
        position: 'absolute',
        right: 10,
        top: 10,
        color: 'primary',
    },
    reservationId: {
        fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif',
        fontSize: '16px',
        fontWeight: 'bold',
        margin: '0 45px',
        position: 'absolute',
        top: 15,
    },
    qrCode: {
        width: '300px',
        margin:'auto',
    },
    pickupCode: {
        fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif',
        fontSize: '60px',
        fontWeight: 'bold',
        textAlign:'center',
        margin: '0',
        width: '100%',
        position: 'absolute',
        bottom: 0,
    },
    actionBtn: {
        marginRight:'5px'
    },

};

class Component extends React.Component {
    state = { open: false, loading: false }

    handleClickOpen = () => {
        this.setState({ open: true })
        this.confirm()
    }

    handleClose = (force) => {
        if (force !== true) {
            if (this.state.loading) return
        }
        this.setState({ open: false, loading: false })
    }

    handleAction = (orderId, print) => {
        this.setState({ loading: true })
        this.props
            .getRecoveryLabelAction(orderId, print)
            .then(() => {
            })
            .catch((error) => {
                this.handleClose(true)
                window.showDialog(error)
            })
        this.setState({ loading: false })
    }

    confirm = () => {
        this.setState({ loading: true })
        this.props
            .getRecoveryBarCodeAction(this.props.orderId)
            .then((response) => {
                var qrCode = `data:application/pdf;base64,${response.qrCode}`
                this.setState({pickupCode: response.code, qrCode: qrCode, reservationId: response.reservationId})
                this.setState({ loading: false })
            })
            .catch((error) => {
                this.handleClose(true)
                window.showDialog(error)
            })
    }

    render() {
        return (
            <div style={{ width: '100%' }}>
                <div onClick={this.handleClickOpen}>
                    {strings.recoveryOrder}
                </div>
                <Dialog
                    open={this.state.open}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    maxWidth='xs'
                    fullWidth={true}
                    scroll='body'
                >
                    <DialogTitle id="alert-dialog-title" >
                        {strings.recoveryOrderTitle}
                        <IconButton aria-label="close" style={styles.closeBtn} onClick={this.handleClose}>
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent dividers>
                        <div style={styles.recoveryCode} width={300}>
                            <p style={styles.reservationId}>
                                {strings.recoveryOrderReservationId} {this.state.reservationId}
                            </p>
                            <img src={this.state.qrCode} style={styles.qrCode} alt='qrcode'></img>
                            <p style={styles.pickupCode}>
                                {this.state.pickupCode}
                            </p>
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button style={styles.actionBtn} color='primary' onClick={()=> this.handleAction(this.props.orderId, true)}>
                            <PrintIcon style={styles.actionBtn} />
                            <span>{strings.recoveryOrderPrint}</span>
                        </Button>
                        <Button style={styles.actionBtn} color='primary' onClick={()=> this.handleAction(this.props.orderId, false)}>
                            <GetAppIcon style={styles.actionBtn}/>
                            <span>{strings.recoveryOrderDownload}</span>
                        </Button>
                    </DialogActions>
                    {this.state.loading ? <Loader /> : null}
                </Dialog>
            </div>
        )
    }
}

const mapDispatchToProps = { getRecoveryLabelAction, getRecoveryBarCodeAction }
const mapStateToProps = (store) => ({})
export default connect(mapStateToProps, mapDispatchToProps)(Component)